<template>
  <component
    :is="component"
    v-editable="isVisualEditor ? block : null"
    :blok="block"
    :context="context"
    class="font-content"
    :class="block.component"
  />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
  block: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const isVisualEditor = import.meta.env.VITE_IS_EDITOR

const component = defineAsyncComponent({
  // the loader function
  loader: async () => await import(`../blocks/${props.block.component}.vue`),
  // A component to use if the load fails
  errorComponent: 'div',
  onError: (error, retry, fail, attempts) => {
    console.warn(
      `Failed to load block ${props.block.component}:\n${error?.message}`,
    )
    if (attempts <= 3) {
      console.log(`Loading it again, attempt #${attempts}`)
      retry()
    } else {
      fail()
    }
  },
})
</script>
